import React from "react";
import { Question } from "../../../../Entities/Question";
import { Typography } from "antd";
import { CopyBlock, atomOneLight } from "react-code-blocks";
import hljs from "highlight.js";

interface JobApplicationinterviewRoundQuestionAnswerProps {
  question: Question;
  isRoundPending: boolean;
}

const languageArray = [
  "javascript",
  "typescript",
  "jsx",
  "python",
  "java",
  "c",
  "cpp",
  "csharp",
  "go",
  "dart",
  "php",
  "ruby",
  "swift",
  "kotlin",
  "sql",
  "html",
  "css",
  "json",
  "bash",
  "shell",
  "yaml",
  "xml",
  "perl",
  "r",
  "rust",
];

const JobApplicationinterviewRoundQuestionAnswer: React.FC<
  JobApplicationinterviewRoundQuestionAnswerProps
> = ({ question, isRoundPending }) => {
  const detectLanguage = (code: string) => {
    const result = hljs.highlightAuto(code, languageArray);
    return result.language;
  };

  const renderAnswer = () => {
    const questionType = question.type.toLocaleLowerCase();
    const userAnswer = isRoundPending
      ? "Waiting for round completion."
      : question.responses?.[0]?.description ||
        "No answer provided by the candidate.";

    switch (questionType) {
      case "mcq":
        return (
          <div className="job-application-interview-rounds-question-answer-container-mcq">
            <Typography.Text strong style={{ fontSize: 13 }}>
              {userAnswer}
            </Typography.Text>
          </div>
        );
      case "coding":
        return (
          <div className="job-application-interview-rounds-question-answer-container-coding">
            <CopyBlock
              text={userAnswer}
              language={
                !isRoundPending
                  ? detectLanguage(userAnswer) || "plaintext"
                  : "plaintext"
              }
              showLineNumbers={false}
              theme={atomOneLight}
              customStyle={{
                overflow: "scroll",
              }}
              codeBlock={true}
            />
          </div>
        );
      case "descriptive":
        return (
          <div className="job-application-interview-rounds-question-answer-container-descriptive">
            <Typography.Text strong style={{ fontSize: 13 }}>
              {userAnswer}
            </Typography.Text>
          </div>
        );
      default:
        return (
          <div className="job-application-interview-rounds-question-answer-container-descriptive">
            {userAnswer}
          </div>
        );
    }
  };
  return (
    <div className="job-application-interview-rounds-question-answer-container">
      {renderAnswer()}
    </div>
  );
};

export default JobApplicationinterviewRoundQuestionAnswer;
